import { render, staticRenderFns } from "./PatientAppointmentGridComponent.vue?vue&type=template&id=2272fe66&scoped=true&"
import script from "./PatientAppointmentGridComponent.vue?vue&type=script&lang=js&"
export * from "./PatientAppointmentGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272fe66",
  null
  
)

export default component.exports